import moment from "@/utils/moment";

export default {
  filters: {
    intToTime(number, format = "HH:mm:ss") {
      if (!number) return number;

      return moment()
        .set({
          hour: number,
          minute: 0,
          second: 0,
          millisecond: 0
        })
        .format(format)
        .toString();
    },

    formatTime(time) {
      return time.split(":")[0] + " hrs";
    },

    secToHours(seconds, withLabel = false) {
      let hours = seconds / 60;

      if (!withLabel) return hours;

      return hours > 1 ? `${hours} horas` : `${hours} hora`;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/timeMixin.js